import React from 'react';
import { Box, IconButton, styled } from '@mui/material';
import AddIcon from '@mui/icons-material/Add'; // Import the generic Add icon

// Styled IconButton for the add event buttons
const StyledIconButton = styled(IconButton)<{ buttoncolor: string }>(({ theme, buttoncolor }) => ({
  display: 'flex',
  flexDirection: 'row',
  justifyContent: 'center',
  alignItems: 'center',
  padding: '20px 0px', // 20px top/bottom, 0px left/right
  gap: theme.spacing(1), // 8px
  width: '91.67px', // From Figma
  height: '56px', // From Figma
  background: '#F2F2F2', // grey5_whitetheme
  borderRadius: '12px',
  flexGrow: 1,
  color: buttoncolor, // Use the passed buttoncolor prop
  '&:disabled': {
    backgroundColor: '#E0E0E0',
    color: '#A8A8A8',
  },
}));

interface AddEventButtonsProps {
  onAddText?: () => void;
  onAddVoice?: () => void;
  onAddPhoto?: () => void;
  onAddLiquid?: () => void;
  showTextButton?: boolean;
  showVoiceButton?: boolean;
  showPhotoButton?: boolean;
  showLiquidButton?: boolean;
  disabled?: boolean;
  buttonColor?: string; // New prop for custom button color
}

export const AddEventButtons: React.FC<AddEventButtonsProps> = ({
  onAddText,
  onAddVoice,
  onAddPhoto,
  onAddLiquid,
  showTextButton = false,
  showVoiceButton = false,
  showPhotoButton = false,
  showLiquidButton = false,
  disabled = false,
  buttonColor = '#41AEE4', // Default color if not provided
}) => {
  return (
    <Box sx={{ display: 'flex', flexDirection: 'row', gap: '8px', width: '100%' }}>
      {showTextButton && (
        <StyledIconButton onClick={onAddText} disabled={disabled} buttoncolor={buttonColor}>
          <AddIcon fontSize="small" />
        </StyledIconButton>
      )}
      {showLiquidButton && (
        <StyledIconButton onClick={onAddLiquid} disabled={disabled} buttoncolor={buttonColor}>
          <AddIcon fontSize="small" />
        </StyledIconButton>
      )}
      {showVoiceButton && (
        <StyledIconButton onClick={onAddVoice} disabled={disabled} buttoncolor={buttonColor}>
          <AddIcon fontSize="small" />
        </StyledIconButton>
      )}
      {showPhotoButton && (
        <StyledIconButton onClick={onAddPhoto} disabled={disabled} buttoncolor={buttonColor}>
          <AddIcon fontSize="small" />
        </StyledIconButton>
      )}
    </Box>
  );
};
